var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_750",
    "data-name": "Grupo 750",
    transform: "translate(-435 -687)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_40",
    "data-name": "Elipse 40",
    cx: 27,
    cy: 27,
    r: 27,
    transform: "translate(435 687)",
    fill: "#009ebe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon_search",
    transform: "translate(445.368 697.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon_search-2",
    "data-name": "icon_search",
    d: "M23.019,20.354a12.283,12.283,0,0,0,2.537-7.565A12.723,12.723,0,0,0,12.869,0,12.878,12.878,0,0,0,0,12.789,12.878,12.878,0,0,0,12.869,25.578a12.083,12.083,0,0,0,7.612-2.522l5.438,5.4a1.76,1.76,0,0,0,2.538,0,1.734,1.734,0,0,0,0-2.522ZM12.869,21.8a9.1,9.1,0,0,1-9.244-9.006,9.244,9.244,0,0,1,18.487,0A9.1,9.1,0,0,1,12.869,21.8Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1659ac231f86b08e0bf02598a852e23d.svg";
export { ForwardRef as ReactComponent };